var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFile = function SvgDownloadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1919",
    fillRule: "evenodd",
    d: "M14.698 6.854v7.184H1.302V6.854h1.03v6.267h11.336V6.854zm-2.899.324L8 10.56 4.2 7.178l.73-.648 2.555 2.274V1.963h1.03v6.841l2.556-2.274z",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadFile;